<template>
    <div class="ui-item" v-if="item" :class="['post-item-' + item.type]">
        <router-link :to="link">
            <div class="image">
                <img v-if="image" :src="image">
            </div>
            <div class="info">
                <h2 class="title" v-html="title"></h2>
                <h3 v-if="sub_title" class="sub-title" v-html="sub_title"></h3>
                <h3 v-else-if="product && product.variants[0].old_inventory_quantity !== 0" class="price">£{{product.variants[0].price}}</h3>
                <h3 v-else-if="product && product.variants[0].old_inventory_quantity === 0" class="price">out of stock</h3>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'ui-item',

    data() {
        return {
            link: '',
            title: '',
            sub_title: '',
            image: '',
            product: false,
        }
    },

    props: {
        item: {
            type: Object,
            default: {}
        },
    },

    mounted() {
        if (this.item.type === 'product' && this.item.select_product) {
            const pid = Number(this.item.select_product);
            const result = this.$store.state.products.filter(item => item.id === pid);
            if (result.length === 1) this.product = result[0];
        }

        if (this.item.featured_image) {
            this.image = this.item.featured_image.medium_large;
        }

        if (this.item.post_title) {
            this.title = this.item.post_title;
        }
        else if (this.item.title) {
            this.title = this.item.title.rendered;
        }

        if (this.item.sub_title) {
            this.sub_title = this.item.sub_title;
        }

        if (this.item.link) {
            this.link = this.item.link.replace(window.globals.home_url, '');
        }
    },
}

</script>

<style lang="scss" scoped>
    .ui-item {
        & > a {
            display: block;
            position: relative;
        }

        .image {
            position: relative;
            background: rgb(241, 241, 241);

            &::before {
                content: '';
                display: block;
                padding: 0 0 133.5%;
            }

            img {
                position: absolute;
                left: 0;
                top: 0;
                // height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }

        .price {
            color: var(--gray);
        }

        &.post-item-product {
            .image::before {
                padding: 0 0 100%;
            }

            .info {
                padding: var(--padding-50) 0 var(--padding-x2);
            }
        }

        &.post-item-category {
            .info {
                position: absolute;
                display: flex;
                left: 0;
                bottom: 0;
                width: 100%;
                box-sizing: border-box;
                padding: var(--padding-x4) var(--padding-x2) var(--padding);
                background: linear-gradient(180deg, rgba(241, 241, 241, 0) 0%, rgba(241, 241, 241, 0.8) 61.98%);
                
                h3 {
                    padding-left: var(--padding);
                    color: var(--gray);
                }
            }
        }

        &.post-item-commission {
            .info {
                padding: var(--padding-50) 0 var(--padding-x2);
                
                h3 {
                    color: var(--gray);
                }
            }
        }

        &.post-item-journal {
            .image {
                overflow: hidden;

                img {
                    height: 100%;
                    width: 100%;
                }

                &::before {
                    padding: 0 0 75%;
                }
            }

            .info {
                padding: var(--padding-50) 0 var(--padding-x2);
            }

            a {
                color: white;
            }

            a:hover {
                color: var(--font-color);
            }
        }

    }

    @media only screen and (max-width: 780px) {
        .ui-item {

  

            &.post-item-product {

                .info {
                    padding: var(--padding-50) 0 var(--padding);
                }
            }

            &.post-item-category {
                .info {
                    display: block;
                    padding: var(--padding);

                    h3 {
                        padding-left: 0;
                    }
                }
            }

            &.post-item-commission {
                .info {
                    padding: var(--padding-50) 0 var(--padding);
                }
            }

            &.post-item-journal {
                .info {
                    padding: var(--padding-50) 0 var(--padding);
                }
            }


        }
    }
</style>